import { SiteType } from '@klareospace/pharos-lib-types';
import * as React from 'react';
import { SiteState } from './site-state';
import { SpaceState } from './space-state';
import { TenantOnlyState } from './tenant-only-state';

// ─── Props ────────────────────────────────────────────────────────────────────

export interface MainSelectorBreadcrumbViewProps {
  interactive?: boolean;
  siteColor?: string;
  siteName?: string;
  siteType?: SiteType;
  spaceName?: string;
  tenantName: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function MainSelectorBreadcrumbView({
  interactive,
  siteColor,
  siteName,
  siteType,
  spaceName,
  tenantName,
}: MainSelectorBreadcrumbViewProps): React.JSX.Element {
  // Show site breadcrumb when we have a site name — siteType may be absent for users
  // without sites:list (drivers/carriers), in which case SiteState renders a generic icon.
  const hasSite = !!siteName;
  const hasSpace = !!spaceName;

  if (hasSite) {
    return (
      <SiteState
        interactive={interactive}
        siteColor={siteColor}
        siteName={siteName}
        siteType={siteType}
        spaceName={spaceName}
        tenantName={tenantName}
      />
    );
  }

  if (hasSpace) {
    return <SpaceState interactive={interactive} spaceName={spaceName} tenantName={tenantName} />;
  }

  return <TenantOnlyState interactive={interactive} tenantName={tenantName} />;
}
